<template>
    <div class="content-wrapper  " style="background-color:#eee ; height: 100%">
<!--        <preLoader v-if="loader"></preLoader>-->
        <div class="container" >
            <div class="form-group" style="margin-top: 30px">
                <router-link :to="{path: '/user/create'}" class="btn btn-success">{{ $t('Add') }}</router-link>
            </div>

            <div class="panel panel-default ">
                <div class="panel-heading">لیست </div>
                <div class="panel-body  ">
                    <div class="table-responsive">



                        <table class="table table-bordered table-striped table-hover">
                            <thead>
                                <tr>
<!--                                    <th> وضعیت</th>-->
                                    <th> {{ $t('Name') }} {{ $t('surname') }}</th>
                                    <th> {{ $t('phone') }}</th>
                                    <th>{{ $t('e-mail') }}</th>
                                    <th>{{ $t('Role managements') }} </th>
                                    <!--<th>وضعیت </th>-->

                                    <th width="100">&nbsp;</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr id="items" v-for="(item, indexitem) in items" :key="indexitem" v-if="item.id != '1'">

<!--                                    <td>{{ item.status }}</td>-->
                                    <td>{{ item.name }}</td>
                                    <td>{{ item.mobile }}</td>
                                    <td>{{ item.email }}</td>
                                    <td>
                                        <!-- Trigger the modal with a button -->
                                        <button type="button" class="btn btn-sm btn-info" data-toggle="modal"
                                            :data-target="`#role-edit-`+item.id" @click="loaderMethod($event,item.id)">نقش
                                          {{ $t('User') }}  </button>

                                        <!-- Modal -->
                                        <div :id="`role-edit-`+item.id" class="modal fade" role="dialog">
                                            <div class="modal-dialog">

                                                <!-- Modal content-->
                                                <div class="modal-content">
                                                    <div class="modal-header">
                                                        <button type="button" class="close"
                                                            data-dismiss="modal">&times;</button>
                                                        <h4 class="modal-title">{{ $t('Role managements') }}</h4>
                                                    </div>
                                                    <div class="modal-body">
                                                        
                                                        <div v-for="(role,index) in roles" :key="index"
                                                            style="margin:5px" :class="`a`+indexitem">
                                                            <input type="radio" class="option-input checkbox"
                                                                @click="checkone(indexitem)" 
                                                                :value="role.id"
                                                                @change="updateRoles(role.id ,item.id)">
                                                            {{  role.name}}
                                                        </div>
                                                        <br>
                                                        <!-- 
                                                        <button :value="item.id" v-on:click=""
                                                            data-dismiss="modal" class="btn btn-success">بروزرسانی خدمات
                                                        </button> -->
                                                    </div>
                                                    <div class="modal-footer">
                                                        <button type="button" class="btn btn-default"
                                                            data-dismiss="modal" @click="removeAttr">{{ $t('Close') }}</button>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </td>



                                    <td>
                                        <!-- <router-link :to="{name: 'edit-userManager', params: {id: item.id}}"
                                            class="btn btn-xs btn-default">
                                            ویرایش
                                        </router-link> -->
                                        <a href="javascript: void(0)" class="btn btn-sm btn-danger m-1"
                                            v-on:click="deleteEntry(item.id, indexitem)">
                                            {{ $t('Delete') }}
                                        </a>


                                        <button type="button" class="btn btn-sm btn-default m-1" data-toggle="modal"
                                                :data-target="'#editUser'+item.id">{{ $t('Edit') }} </button>


                                        <!--<router-link :to="{name: 'edit-gift', params: {id: item.id}}"-->
                                                     <!--class="btn btn-xs btn-default">-->
                                            <!--{{ $t('Edit') }}-->
                                        <!--</router-link>-->

                                    </td>





                                    <!-- Modal -->
                                    <div :id="'editUser'+item.id" class="modal fade" role="dialog">
                                        <div class="modal-dialog">
                                            <!-- Modal content-->
                                            <div class="modal-content">
                                                <div class="modal-header">
                                                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                                                    <h4 class="modal-title"> {{ $t('Edit') }} (Change Password) </h4>
                                                </div>

                                                <div class="modal-body">
                                                    <div style="margin:5px">



                                                        <div class="col-xs-12 form-group">
                                                            <label class="control-label"> نام و نام خانودگی
                                                            </label>
                                                            <input type="text" v-model="item.name" class="form-control">
                                                        </div>

                                                        <div class="col-xs-12 form-group">
                                                            <label class="control-label"> ایمیل
                                                            </label>
                                                            <input type="email" v-model="item.email" class="form-control">
                                                        </div>

                                                        <div class="col-xs-12 form-group">
                                                            <label class="control-label"> موبایل
                                                            </label>
                                                            <input type="text" v-model="item.mobile" class="form-control">
                                                        </div>

                                                        <div class="col-xs-12 form-group">
                                                            <label class="control-label">  پسورد جدید
                                                            </label>
                                                            <input type="password" v-model="item.password" class="form-control">
                                                        </div>


                                                        <div class="col-xs-12 form-group">
                                                            <label class="control-label">{{ $t('status') }}</label>
                                                            <select class="form-control" v-model="item.status ">
                                                                <option value="0">{{ $t('Inactive') }}</option>
                                                                <option value="1">{{ $t('Active') }}</option>
                                                            </select>

                                                        </div>




                                                    </div>
                                                    <br>

                                                    <button   v-on:click="editEntry(item)" data-dismiss="modal" class="btn btn-success"> ویرایش </button>

                                                    <button type="button" class="btn btn-default" data-dismiss="modal">بستن</button>
                                                </div>
                                            </div>
                                            <!-- <div class="modal-footer">
                                                <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>

                                            </div> -->
                                        </div>

                                    </div>

                                </tr>
                            </tbody>
                        </table>
                        <!-- Trigger the modal with a button -->

                        <!-- Modal -->

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    const auth = {
        headers: {
            Authorization: 'bearer ' + localStorage.getItem('token')
        }
    };

    export default {

        data: function () {
            return {
                auth: {
                    headers: {
                        Authorization: 'bearer ' + localStorage.getItem('token')
                    }
                },
                roles: [],
                items: [],
                chechedItem: [],
                loader: false,
                userlength: '',
                errors: [],
                userRole: []

            }
        },
        created() {


            // console.log(this.items.roles)
        },

        mounted() {
            this.loader=true
            axios
                .get('/admin-api/v1/role/list', this.auth)
                .then(response => {
                    this.roles = response.data.data;
                    //   console.log(this.roles,"ss");
                    this.loader=false

                })
                .catch(error => {
                    this.loader = false
                    if (error.response.data.message == 'User does not have any of the necessary access rights.') {
                        this.$snotify.warning('دسترسی شما برای این بخش محدود شده است');
                    } else {
                        this.$snotify.warning(error.response.data.message);
                    }

                    console.log(error);
                    this.errored = true
                })
                .finally(() => this.loading = false)

            // console.log(this.items)

            axios
                .get('/admin-api/v1/user/list', this.auth)
                .then(response => {
                    // this.loader = false;
                    this.items = response.data.data
                    console.log(response.data.data)
                    this.userlength = response.data.data.length
                    // console.log(response.data.data.id);
                    //   console.log(this.userRoles(1))
                    for (const key in response.data.data) {


                        if (this.items.hasOwnProperty(key)) {

                            const element = this.items[key];
                            // console.log(element.id)
                            this.userRoles(key, element.id)


                        }

                    }
                    //  this.loader = true
                    //    console.log(this.items[0].roles ,"11")
                    //   console.log(this.m)

                })
                .catch(error => {
                    console.log(error);
                    this.errored = true
                })
                .finally(() => this.loading = false)

        }


        ,
        methods: {

            checkone(id) {
                var radios = $(`.a${id}>input[type="radio"] `);

                radios.change(function () {
                    radios.not(this).prop('checked', false);
                });
            },

            updateRoles(role, user) {
                if (confirm("از تغییر نقش آیتم مطمئن هستید؟")) {
                    axios.post(`/admin-api/v1/role/change-user-role`, {
                            roleId: role,
                            userId: user
                        }, this.auth)
                        .then(function (resp) {

                            this.$snotify.success('نقش کاربر با موفقیت تغییر یافت');
                            console.log(resp)
                            // console.log(resp)
                        })
                        .catch(
                            e => {
                                this.errors.push(e.response.data.message);
                                //   console.log(this.errors)
                                for (const error of this.errors) {
                                    this.$snotify.warning(error);
                                }
                                // console.log(e)
                            }
                        );
                }


            },



            editEntry(item) {

                if (confirm("از ویرایش کاربر مطمئن هستید؟")) {
                    var app = this
                    var newItem = item

                    axios.post('/admin-api/v1/user/update/' + newItem.id , newItem ,app.auth)

                        .then(function (resp) {

                            app.$snotify.success('ویرایش با موفقیت انجام شد');

                        })
                        .catch(function (resp) {
                            app.$snotify.warning("امکان ویرایش آیتم وجود ندارد");

                        });
                }
            },



            deleteEntry(id, index) {
                if (confirm("{{$customerLable}} مرتبط با این کاربر حذف خواهد شد! آیا از حذف مطمئن هستید؟")) {
                    var app = this;
                    axios.get('/admin-api/v1/user/delete/' + id, app.auth)

                        .then(function (resp) {

                            app.$snotify.success('حذف با موفقیت انجام شد');

                            app.items.splice(index, 1);
                        })
                        .catch(function (resp) {
                            app.$snotify.warning("امکان حذف آیتم وجود ندارد");

                        });
                }
            },

            loaderMethod(e, userId) {
             this.loader=true
                axios
                    .get('/admin-api/v1/user-role/list?userId=' + userId, this.auth)
                    .then(response => {

                        console.log(response.data.data)
                        this.userRole = response.data.data

                        e.target.parentElement.querySelectorAll("input").forEach(element => {
                            if (this.userRole.find(x => x.id == element.value)) {
                                element.checked = true
                            } else {
                                element.checked = false
                            }

                        })
                        this.loader=false
                        // e.target.setAttribute("data-toggle","modal")
                        //  this.chekcedRoles(userId)
                        //    console.log(parseInt(key)+1);
                        // this.items[key].roles = response.data.data;
                        // if (this.userlength <= parseInt(key) + 1) {

                        //     this.loader = true
                        // }

                        //    return data

                    })
                    .catch(error => {
                        console.log(error);
                        this.errored = true
                    })
                    .finally(() => this.loading = false)
            },
            removeAttr(e){
                // console.log(e.target.parentElement)
                
            }


        }
    }

</script>
